import LandingInput from '@/components/LandingInput'
import AddressInput from '@/components/LandingInput/AddressInput'
import { t } from '@/utils/language'
import scanQRCode from './img/Scan-QR-code.png'
import accessMenu from './img/Access-menu.png'
import notification from './img/Notification.png'
import WaitTime from './img/WaitTime.png'
import PlaceOrder from './img/PlaceOrder.png'
import {
  getForm
} from 'api/product'

const emailNumberRule = (rule, value, callback) => {
  const reg = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/
  if (!reg.test(value)) {
    callback(new Error('Please provide a vaild email adddress'))
  }
  callback()
}
const phoneNumberRule = (rule, value, callback) => {
  value = value.trim()
  const reg = /^[0-9+]+$/
  if (isNaN(value)) {
    callback(new Error('Mobile number format is incorrect'))
  }
  // if (!reg.test(value)) {
  //   callback(new Error('Please enter your Mobile number'))
  // }
  // if (value.length < 6) {
  //   callback(new Error('Mobile number is greater than 6'))
  // }
  // if (value.length > 14) {
  //   callback(new Error('Mobile number is greater less than 14'))
  // }
  callback()
}
// 表单 name 验证
const validateName = (rule, value, callback) => {
  const reg = /^[a-zA-Z0-9\-' \u4e00-\u9fa5]+$/
  if (!reg.test(value)) {
    callback(new Error('Full name is not valid.'))
  }
  callback()
}

export default {
  props: {
    isCom: {
      type: Boolean,
      default: false
    }
  },

  components: {
    LandingInput,
    AddressInput,
  },

  computed: {
    headerTitle() {
      return this.$route.name === 'aov' ? 'Sell more with QR code table ordering' : 'MondoMenu makes delivery & pickup orders easy'
    },

    headerImg() {
      return require('./img/AOV-header-image.png')
    },

    headerText() {
      return ['Grow your average order value by over 40%', 'Sell more high-profit items and add-ons', 'Pay no commissions', '100 day risk-free guarantee']
    },

    isAov() {
      return this.$route.name === 'aov'
    },

    whyList() {
      return this.isAov ? ['Simple, transparent and fair pricing with no hidden costs', 'Easily configurable to suit your unique business requirements', 'Deliver yourself or use one of our trusted delivery partners', 'Stop paying 35% commissions to Uber and MenuLog', 'Pass on merchant fees', 'Allow customers to pre-order', 'Integrate with your POS or use standalone'] : ['Simple, transparent and fair pricing with no hidden costs', 'Easily configurable to suit your unique business requirements', 'QR code table ordering option available', 'Deliver yourself or use one of our trusted delivery partners', 'Stop paying 35% commissions to Uber and MenuLog', 'Pass on merchant fees', 'Allow customers to pre-order', 'Integrate with your POS or use standalone']
    },

    profitabilityList() {
      const aov = {
        img: require('./img/Sell.jpg'),
        title: 'Images help sell',
        text: 'Customers spend more when they can see beautiful images of your food.'
      }
      const upsell = {
        img: require('./img/Upsell.jpg'),
        title: 'Upselling made easy',
        text: 'Upsell and cross sell using our easy to implement menu features.'
      }
      const passOnFees = {
        img: require('./img/Back.jpg'),
        title: 'Bring them back',
        text: 'Build a customer database. Detailed reporting & analytics provide you with insights for future marketing activities.'
      }
      return this.$route.name === 'aov' ? [aov, upsell, passOnFees] : [aov, upsell, passOnFees]
    }
  },

  watch: {
    isCom: {
      immediate: true,
      handler(val) {
        if (!val) document.documentElement.scrollTop = 0 // 切换组件时，默认回到顶部
      }
    },
  },

  data() {
    return {
      openShow: false,
      scanQRCode,
      accessMenu,
      notification,
      WaitTime,
      PlaceOrder,

      formRuleValidate: {
        firstName: [{
          required: true,
          message: t('please_enter_full_name', 'Please enter your full name'),
          trigger: 'blur'
        },
        {
          validator: validateName,
          trigger: 'blur'
        }
        ],
        email: [{
          required: true,
          message: t('please_enter_email', 'Please enter your email'),
          trigger: 'blur'
        },
        {
          validator: emailNumberRule,
          trigger: 'blur'
        }
        ],
        mobile: [{
          required: false,
          message: t('please_enter_mobile', 'Please enter your mobile number'),
          trigger: 'blur'
        },
        {
          validator: phoneNumberRule,
          trigger: 'blur'
        }
        ],
        jobTitle: [{
          required: true,
          message: t('please_enter_job_title', 'Please enter your job title'),
          trigger: 'blur'
        }],
        // address: [{
        //   required: true,
        //   message: 'Please enter your venue location',
        //   trigger: 'blur'
        // }],
        // posSystem: [{
        //   required: false,
        //   message: 'Please enter your POS brand',
        //   trigger: 'blur'
        // }],
      },

      formLabelAlign: {
        firstName: '',
        lastName: '',
        email: '',
        subject: '',
        message: '',
        code: '',
        mobile: '',
        jobTitle: '',
        address: '',
        posSystem: '',
        interested: [],
        contactMethod: 'Email',
        venueName: ''
      },

      userInfo: {
        userAddress: ''
      },

      oldUserInfo: {
        rawAddress: '',
        address: '',
        postcode: '',
      },

      userPostcode: '',
      rawAddress: '',

      bounceOpacity: 1,

      visible: 'visible'
    }
  },

  async mounted() {
    window.addEventListener('scroll', this.scrollToTop)
    await this.$nextTick()
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((i) => {
          if (i.intersectionRatio > 0.5) {
            i.target.classList.add('animation')
          }
        })
      },
      {
        threshold: [0, 0.25, 0.5, 0.75, 1],
      },
    )
    const ioc = new IntersectionObserver(
      (entries) => {
        entries.forEach((i) => {
          if (i.target.classList.value === 'app_header aov_public_profitability') {
            return
          }
          this.bounceOpacity = 1 - i.intersectionRatio
        })
      },
      {
        threshold: [0, 0.25, 0.5, 0.75, 1],
      },
    )
    const box = document.getElementsByClassName('content_box')
    const aov = document.getElementsByClassName('aov_public_profitability')
    for (const item of box) {
      io.observe(item)
    }
    ioc.observe(aov[0])
  },

  destroyed() {
    window.removeEventListener('scroll', this.scrollToTop)
  },

  methods: {
    t(key, fallback) { return t(key, fallback) },

    // 跳转至表单区域
    goMore() {
      document.getElementById('more').scrollIntoView({
        behavior: 'smooth',
      })
    },

    async submitFrom(type) {
      const result = await this.$refs.form.validate()
      if (result) {
        this.$store.commit('showLoading')
        // 没装 vue-gtag（菜单预览页，多版本菜单 B6 U-B6-3）时 $gtag 不存在
        if (this.$gtag) {
          this.$gtag.event('Submit', {
            event_category: 'Form',
            event_label: 'Enquiry',
          })
        }
        const data = this._setData()
        await getForm(data).catch(error => {
          console.log(error)
          this.$store.commit('closeLoading')
        })
        this._initializationData()
        this.openShow = true
        this.$store.commit('closeLoading')
      }
    },

    scrollToTop() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      if (scrollTop > 300) {
        this.visible = 'hidden'
      } else {
        this.visible = 'visible'
      }
    },

    nextPage() {
      const aov = document.getElementsByClassName('aov_public_profitability')
      this.$nextTick(() => {
        aov[0].scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        })
      })
    },

    submitUserAddress() {
      this.formLabelAlign.address = this.oldUserInfo.address
    },

    _setData() {
      return {
        firstName: this.formLabelAlign.firstName,
        lastName: '',
        email: this.formLabelAlign.email,
        subject: '',
        message: '',
        code: '',
        venueName: this.formLabelAlign.venueName,
        extra: {
          mobile: this.formLabelAlign.mobile,
          jobTitle: this.formLabelAlign.jobTitle,
          // address: {
          //   value: this.formLabelAlign.address,
          //   googleResult: this.oldUserInfo.rawAddress
          // },
          // posSystem: this.formLabelAlign.posSystem,
          interested: this.formLabelAlign.interested,
          type: this.$route.name,
          contactMethod: this.formLabelAlign.contactMethod
        }
      }
    },

    _initializationData() {
      this.formLabelAlign = {
        firstName: '',
        lastName: '',
        email: '',
        subject: '',
        message: '',
        code: '',
        mobile: '',
        jobTitle: '',
        address: '',
        posSystem: '',
        venueName: '',
        interested: [],
        contactMethod: 'Email'
      }

      this.userInfo = {
        userAddress: ''
      }

      this.oldUserInfo = {
        rawAddress: '',
        address: '',
        postcode: '',
      }

      this.userPostcode = ''
      this.rawAddress = ''
    },

    toRouter(label) {
      if (label === 'facebook') window.open('https://www.facebook.com/MondoMenu2020')
      else window.open('https://www.instagram.com/mondomenu2020/')
    }
  }
}
